import { Checkbox, ICheckbox, IColumn, ICommandBarItemProps, Icon, Label, Stack, TooltipHost } from "@fluentui/react";
import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { HeadingBar } from "../../../components/Generic/HeadingBar";
import { IException } from "../../../interfaces/base/IBase";
import { IButtonGroup, IDataCollection, IPagination } from "../../../interfaces/base/ITable";
import { IEmpresa } from "../../../interfaces/IEmpresa";
import { Ifilter, IfilterEmpresa } from "../../../interfaces/IFilter";
import EmpresaService from "../../../services/empresaService";
import { baseSearch, splitExceptionDetail, stackTokensHorizontal, _initialFilter, _initialPagination } from "../../../utils/Helper/helper";
import { IconHelper } from "../../../utils/Helper/iconHelper";
import { _initialDataCollection } from "../../../utils/Helper/tableHelper";
import ThemeBase from "../../../utils/Theme/themeBase";
import { useBoolean } from "@fluentui/react-hooks";
import { ActualizarEmpresa } from "./actualizarEmpresa/actualizarEmpresa";
import { ConfigHelper } from "../../../utils/Helper/configHelper";
import { UseEmpresa } from "./UseEmpresa";
import { TableComponent } from "../../../components/Table/TableComponent";
import { useMakeStyle } from "../../../functions/BaseStyle";
import { PanelGenerico } from "../../../components/Generic/PanelGenerico";

export const ListarConfiguracionEmpresa = () => {
    const navigate = useNavigate();
    const style = useMakeStyle();

    const [hidden, setHidden] = useState(false);
    const [column, setColumn] = useState<IColumn[]>([]);
    const [empresa, setEmpresa] = useState<IDataCollection<IEmpresa[]>>(_initialDataCollection);
    const [filter, setFilter] = useState<IfilterEmpresa>(_initialFilter);
    const [filterEsTitular, setFilterEsTitular] = useState<boolean>(false);
    const [filterEsTransportista, setFilterEsTransportista] = useState<boolean>(false);
    const [filterEsVuelo, setFilterEsVuelo] = useState<boolean>(false);
    const [filterTrasladoTitular, setFilterTrasladoTitular] = useState<boolean>(false);
    const [filterTrasladoContratista, setFilterTrasladoContratista] = useState<boolean>(false);
    const [searchParam, setSearchParam] = useSearchParams();

    const [
        isOpenPanelSearch,
        { setTrue: OpenPanelSearch, setFalse: dismissPanelSearch },
    ] = useBoolean(false);

    useEffect(() => {
        reloadInitial();
    }, [isOpenPanelSearch]);

    const clearPanelSearch = () => {
        dismissPanelSearch();
    };

    const { items, loadingTabla, pagination, handleResetUpdate, onChangeSearch, setDataEdit, dataEdit } = UseEmpresa(filter)


    /* Form */
    const [isOpenEdit, { setTrue: openEdit, setFalse: dismissEdit },] = useBoolean(false);
    const [selItem, setSelItem] = useState<IEmpresa>(null!);

    /* Pagination */
    const [currentPage, setCurrentPage] = useState(_initialPagination().currentPage);
    const [pageSize, setPageSize] = useState(_initialPagination().pageSize);
    const [total, setTotal] = useState(_initialPagination().total);

    const [pager, setPager] = useState<IPagination>({
        ..._initialPagination(),
        onPageChange: (page) => dataByPager(page),
        onSizeChange: (pageSize) => setPageSize(pageSize),
    });

    /* Hook */
    useEffect(() => {
        reloadInitial();
    }, []);

    /* useEffect(() => {
        if (filter) {
            dataEmpresa();
        }
    }, [filter]); */

    /* Hook Pagination */
    useEffect(() => {
        setPager({
            ...pager,
            currentPage: currentPage,
        });

        if (filter) {
            setFilter({
                ...filter,
                skip: (currentPage - 1) * pageSize,
                take: pageSize,
                esTitular: filterEsTitular,
                esTransportista: filterEsTransportista,
                esVuelo: filterEsVuelo,
                trasladoTitular: filterTrasladoTitular,
                trasladoContratista: filterTrasladoContratista
            });
        }
    }, [currentPage]);

    useEffect(() => {
        setFilter({
            ...filter,
            skip: (currentPage - 1) * pageSize,
            take: pageSize,
            esTitular: filterEsTitular,
            esTransportista: filterEsTransportista,
            esVuelo: filterEsVuelo,
            trasladoTitular: filterTrasladoTitular,
            trasladoContratista: filterTrasladoContratista
        });
        dataEmpresa()
    }, [filterEsTitular, filterEsTransportista, filterEsVuelo, filterTrasladoTitular, filterTrasladoContratista])

    useEffect(() => {
        setPager({
            ...pager,
            onPageChange: (page) => dataByPager(page),
            onSizeChange: (pageSize) => setPageSize(pageSize),
            total: total,
        });
    }, [total]);

    /* Api */
    const dataEmpresa = (param = filter) => {
        setEmpresa(_initialDataCollection);
        EmpresaService.all(param).then(res => {
            if (res.status == 200) {
                setEmpresa(res.data);
                setTotal(res.data.total);
            }
            setHidden(true);
        }).catch((e: IException) => {
            setHidden(true);
            alert(splitExceptionDetail(e));
        })
    }

    /* Function */
    const reloadInitial = (param = filter) => {
        setHidden(false);
        setTitleColumn();
        dataEmpresa(param);
    }

    const _columns: IColumn[] = [
        {
            key: "numeracion",
            name: "N°",
            fieldName: "numeracion",
            minWidth: 30,
            maxWidth: 50,
            onRender: (item, index) => <>{(index ?? 0) + 1}</>
        },
        {
            key: 'doi',
            name: 'DOI',
            fieldName: 'doi',
            minWidth: 80,
            maxWidth: 100,
            isResizable: true,
            data: 'string',
            isPadded: true,
        },
        {
            key: 'nombre',
            name: 'Nombre',
            fieldName: 'nombre',
            minWidth: 200,
            maxWidth: 250,
            isResizable: true,
            data: 'string',
            isPadded: true,
        },
        {
            key: 'nombreCorto',
            name: 'Nombre Corto',
            fieldName: 'nombreCorto',
            minWidth: 200,
            maxWidth: 200,
            isResizable: true,
            data: 'string',
            isPadded: true,
        },
        {
            key: 'esTitular',
            name: 'Es Titular',
            fieldName: 'esTitular',
            minWidth: 80,
            maxWidth: 80,
            isResizable: true,
            // data: 'string',
            // isPadded: true,
        },
        {
            key: 'esTransportista',
            name: 'Es Transportista',
            fieldName: 'esTransportista',
            minWidth: 80,
            maxWidth: 80,
            isResizable: true,
            data: 'string',
            isPadded: true,
        },
        {
            key: 'esVuelo',
            name: 'Es Vuelo',
            fieldName: 'esVuelo',
            minWidth: 80,
            maxWidth: 80,
            isResizable: true,
            data: 'string',
            isPadded: true,
        },
        {
            key: 'trasladoTitular',
            name: 'Traslado Titular',
            fieldName: 'trasladoTitular',
            minWidth: 100,
            maxWidth: 120,
            isResizable: true,
            data: 'string',
            isPadded: true,
        },
        {
            key: 'trasladoContratista',
            name: 'Traslado Contratista',
            fieldName: 'trasladoContratista',
            minWidth: 110,
            maxWidth: 120,
            isResizable: true,
            data: 'string',
            isPadded: true,
        },
        {
            key: "opciones",
            name: "Opciones",
            minWidth: 80,
            maxWidth: 100,
            fieldName: "opciones",
            isResizable: true,
            onRender: (item: IEmpresa) => renderOpciones(item)
        },
    ]

    function renderOpciones(item: IEmpresa) {
        return (
            <div style={{
                display: "flex",
                gap: "10px",
            }}>
                <TooltipHost content={`Editar Empresa`}>
                    <Icon
                        iconName="Edit"
                        style={{ cursor: "pointer" }}
                        className={ThemeBase.classes.iconFont}
                        onClick={() => {
                            setDataEdit(item);
                            openEdit();
                            setSelItem(item);
                        }} />
                </TooltipHost>
                <TooltipHost content={`Usuarios`}>
                    <Icon iconName='Group'
                        style={{ cursor: 'pointer' }}
                        className={ThemeBase.classes.iconFont}
                        onClick={() => {
                            navigate(`${ConfigHelper.urlBase()}/configuraciones/empresas/usuarios/${item.empresaId}`);
                        }}
                    />
                </TooltipHost>
            </div>
        );
    }

    const buttonLeft: IButtonGroup[] = [
        {
            onClick: handleResetUpdate,
            text: "Actualizar",
        },
    ];

    const buttonRight: IButtonGroup[] = [
        {
            onClick: OpenPanelSearch,
            text: "Filtrar",
        },
    ];

    const _leftBar = () => {
        const _items: ICommandBarItemProps[] = [
            {
                ...IconHelper.ICON_RELOAD,
                onClick: () => reloadInitial()
            },
        ];
        return _items;
    }

    const setTitleColumn = () => {
        let col: IColumn[] = [
            {
                key: 'doi',
                name: 'DOI',
                fieldName: 'doi',
                minWidth: 250,
                maxWidth: 250,
                isResizable: true,
                data: 'string',
                isPadded: true,
            },
            {
                key: 'nombre',
                name: 'Nombre',
                fieldName: 'nombre',
                minWidth: 250,
                maxWidth: 250,
                isResizable: true,
                data: 'string',
                isPadded: true,
            },
            {
                key: 'nombreCorto',
                name: 'Nombre Corto',
                fieldName: 'nombreCorto',
                minWidth: 200,
                maxWidth: 200,
                isResizable: true,
                data: 'string',
                isPadded: true,
            },
            {
                key: 'esTitular',
                name: 'Es Titular',
                fieldName: 'esTitular',
                minWidth: 80,
                maxWidth: 80,
                isResizable: true,
                data: 'string',
                isPadded: true,
            },
            {
                key: 'esTransportista',
                name: 'Es Transportista',
                fieldName: 'esTransportista',
                minWidth: 80,
                maxWidth: 80,
                isResizable: true,
                data: 'string',
                isPadded: true,
            },
            {
                key: 'esVuelo',
                name: 'Es Vuelo',
                fieldName: 'esVuelo',
                minWidth: 80,
                maxWidth: 80,
                isResizable: true,
                data: 'string',
                isPadded: true,
            },
            {
                key: 'trasladoTitular',
                name: 'Traslado Titular',
                fieldName: 'trasladoTitular',
                minWidth: 80,
                maxWidth: 80,
                isResizable: true,
                data: 'string',
                isPadded: true,
            },
            {
                key: 'trasladoContratista',
                name: 'Traslado Contratista',
                fieldName: 'trasladoContratista',
                minWidth: 80,
                maxWidth: 80,
                isResizable: true,
                data: 'string',
                isPadded: true,
            },
            {
                key: "opciones",
                name: "Opciones",
                fieldName: "opciones",
                minWidth: 90,
                maxWidth: 120,
                isResizable: true,
                isCollapsible: true,
                data: "number",
                onRender: (item: IEmpresa) => (
                    <>
                        <Stack horizontal tokens={stackTokensHorizontal}>
                            <>
                                <TooltipHost content={`Editar Empresa`}>
                                    <Icon
                                        iconName="Edit"
                                        style={{ cursor: "pointer" }}
                                        className={ThemeBase.classes.iconFont}
                                        onClick={() => {
                                            openEdit();
                                            setSelItem(item);
                                        }} />
                                </TooltipHost>
                                <TooltipHost content={`Usuarios`}>
                                    <Icon iconName='Group'
                                        style={{ cursor: 'pointer' }}
                                        className={ThemeBase.classes.iconFont}
                                        onClick={() => {
                                            navigate(`${ConfigHelper.urlBase()}/configuraciones/empresas/usuarios/${item.empresaId}`);
                                        }}
                                    />
                                </TooltipHost>
                            </>
                        </Stack>
                    </>
                ),
            },
        ];

        setColumn(col);
    }

    const _getFilter = () => {
        return searchParam.get(baseSearch) ?? '';
    }

    /* Event */
    const _onChangeText = (ev?: React.ChangeEvent<HTMLInputElement>, newValue?: string) => {
        if (newValue === '') {
            let f: Ifilter = _initialFilter();
            setFilter(f);
            reloadInitial(f);
        }

        if (newValue != undefined) {
            setSearchParam({
                [baseSearch]: newValue
            });
        }
    };

    const _onPress = (newValue: string) => {
        let f: Ifilter = {
            ..._initialFilter(),
            search: newValue,
        }

        setPager({
            ...pager,
            currentPage: _initialPagination().currentPage
        })

        reloadInitial(f);
        setFilter(f);
    };

    /* Event Filter */
    const _onClearSearch = () => {
        let f: Ifilter = {
            ..._initialFilter(),
            search: ''
        }
        reloadInitial(f);
        setFilter(f);

        setSearchParam({
            [baseSearch]: ''
        });
    }

    /* Event Pagination */
    const dataByPager = (page) => {
        if (true) {
            setTotal(0);

            setPager({
                ...pager,
                currentPage: page,
            });

            let f: Ifilter = {
                ...filter,
                skip: (page - 1) * pageSize,
                take: pageSize,
            }

            setFilter(f);
            setCurrentPage(page);

            reloadInitial(f);
        }
    }

    const _onChangeCheckbox = (
        type: string,
        event: React.FormEvent<HTMLElement> | undefined
    ) => {
        if (event) {
            const isChecked = (event.currentTarget as HTMLInputElement).checked;

            const stateUpdaterMap: { [key: string]: React.Dispatch<React.SetStateAction<boolean>> } = {
                'titular': setFilterEsTitular,
                'transportista': setFilterEsTransportista,
                'vuelo': setFilterEsVuelo,
                'trasladoTitular': setFilterTrasladoTitular,
                'trasladoContratista': setFilterTrasladoContratista
            };

            stateUpdaterMap[type]?.(isChecked);
        }
    };


    return (
        <div className={style.body}>
            <HeadingBar
                title='Empresas'
                subTitle='Gestión de Empresas'
                searchShow={false}
            // searchChange={_onChangeText}
            // searchHandler={_onPress}
            // searchValue={_getFilter()}
            // onClearHandler={_onClearSearch}
            ></HeadingBar>

            <PanelGenerico
                isOpen={isOpenPanelSearch}
                onDismiss={dismissPanelSearch}
                isOnRenderHeader
                disabledFooter={false}
                iconHeaderName={IconHelper.ICON_FILTERS.filterPanel}
                title="Filtro Personalizado"
                subTitle=" Elija las condiciones para filtro personalizado"
                textRegister="Buscar"
                cancelar={clearPanelSearch}
                registrar={dismissPanelSearch}
                disabledIconHeader={false}
            >
                <div
                    className="ms-Grid"
                    dir="ltr"
                    style={{
                        paddingLeft: "10px",
                        paddingRight: "10px",
                        paddingTop: "5%",
                    }}
                >
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg6">
                            <Label>¿Es Titular?</Label>
                            <Checkbox label={filterEsTitular ? 'Si' : 'No'} required={false} onChange={(e) => _onChangeCheckbox("titular", e)} checked={filterEsTitular} />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg6">
                            <Label>¿Es Transportista?</Label>
                            <Checkbox label={filterEsTransportista ? 'Si' : 'No'} required={false} onChange={(e) => _onChangeCheckbox("transportista", e)} checked={filterEsTransportista} />
                        </div>
                    </div>
                    <br />
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg6">
                            <Label>¿Es Vuelo?</Label>
                            <Checkbox label={filterEsVuelo ? 'Si' : 'No'} required={false} onChange={(e) => _onChangeCheckbox("vuelo", e)} checked={filterEsVuelo} />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg6">
                            <Label>¿Traslado Titular?</Label>
                            <Checkbox label={filterTrasladoTitular ? 'Si' : 'No'} required={false} onChange={(e) => _onChangeCheckbox("trasladoTitular", e)} checked={filterTrasladoTitular} />
                        </div>
                    </div>
                    <br />
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg6">
                            <Label>¿Traslado Contratista?</Label>
                            <Checkbox label={filterTrasladoContratista ? 'Si' : 'No'} required={false} onChange={(e) => _onChangeCheckbox("trasladoContratista", e)} checked={filterTrasladoContratista} />
                        </div>
                    </div>
                </div>
            </PanelGenerico>


            {/* <TableBase leftBar={_leftBar()} column={column} data={empresa?.items} pagination={pager} isLoading={!hidden}></TableBase> */}
            <TableComponent
                data={items}
                leftButtons={buttonLeft}
                rightButton={buttonRight}
                column={_columns}
                paginacion={pagination}
                isLoading={loadingTabla}
                isSearch={true}
                onChangeSearch={onChangeSearch}
            />

            <ActualizarEmpresa
                empresaData={dataEdit}
                isOpen={isOpenEdit}
                onDismiss={dismissEdit}
                reload={handleResetUpdate}
            />
        </div>
    )
}